export default "__VITE_ASSET__3pZbt1X8__"